// extracted by mini-css-extract-plugin
module.exports = {"tabs":"formLine_tabs__3jieI","eliminar":"formLine_eliminar__29Nw0","config-list":"formLine_config-list__3SPKY","delete-config":"formLine_delete-config__2CT7x"};